<div class="snackbar-new">
  <img
    class="snackbar-new__doodat"
    src="assets/icons/icon-snackbar-doodat.png"
    alt=""
    aria-hidden="true"
  />

  <div class="snackbar-new__content">
    <p class="snackbar-new__heading">{{ data.heading }}</p>
    <p class="snackbar-new__message">{{ data.message }}</p>
  </div>

  <button
    *ngIf="data.actionText"
    type="button"
    class="snackbar-new__action"
    (click)="snackBarRef.dismissWithAction()"
  >{{ data.actionText }}</button>

  <svg-icon
    class="snackbar-new__close"
    src="assets/icons/icon-close.svg"
    role="button"
    aria-label="Dismiss"
    (click)="onClose()"
  ></svg-icon>
</div>
